<fieldset class="annotation-table transcript-sequence-select">
  <legend>
    Sequence

    <app-help-link [route]="'/documentation/gene-page-sequence'"
                   [title]="'Click to view documentation for the Sequence section'">
    </app-help-link>
  </legend>

  <div *ngIf="geneDetails.transcripts.length > 1" class="transcript-select">
    Select a transcript:
    <select title="Select transcript" [(ngModel)]="transcriptIndex" (change)="transcriptChanged()">
      <option *ngFor = "let transcript of geneDetails.transcripts; let idx = index"
              [ngValue]="idx">
        {{transcript.uniquename}}
      </option>
    </select>
  </div>

  <div>
    <div *ngIf="hasTranscripts">
        <div class="controls">
          <div *ngIf="featureHasProtein()">
          <input id="show-translation" type="checkbox" [(ngModel)]="showNucSequence"
                 (ngModelChange)="updateSequence()"/>
          <label for="show-translation">Show nucleotide sequence</label>
          </div>

          <div class="transcript-part-selection" *ngIf="showNucSequence">
            <div class="seq-title">
              Display sequence of these gene parts:
            </div>

            <div class="flanking-bases">
              <input title="Upstream bases" id="upstream-bases" type="number" min="0"
                     [(ngModel)]="upstreamBases" (ngModelChange)="updateSequence()"/>
              bases upstream
              <span *ngIf="featureHasProtein() && include5PrimeUtr">of UTR</span>
              <span *ngIf="!(featureHasProtein() && include5PrimeUtr)">
                <span *ngIf="featureHasProtein()">of translation start</span>
                <span *ngIf="!featureHasProtein()">of gene start</span>
              </span>
            </div>
            <div class="checkbox-section" *ngIf="featureHasProtein()">
            <div *ngIf="has5PrimeUtr">
            <input id="include-5-prime" type="checkbox" [(ngModel)]="include5PrimeUtr"
                   (ngModelChange)="updateSequence()"/>
            <label for="include-5-prime">5'UTR</label>
            </div>
            <div *ngIf="!has5PrimeUtr">
              (no 5' UTR)
            </div>
            </div>

            <div class="checkbox-section">
              <input id="include-exons" type="checkbox" [(ngModel)]="includeExons"
                     (ngModelChange)="updateSequence()"/>
              <label for="include-exons">Exons</label>
            </div>

            <div class="checkbox-section" *ngIf="cdsIntronCount > 0 || fivePrimeIntronCount > 0 || threePrimeIntronCount > 0">
            <input id="include-introns" type="checkbox" [(ngModel)]="includeIntrons"
                   (ngModelChange)="updateSequence()"/>
            <label for="include-introns">Introns</label>
            <div class="utr-intron-warning" *ngIf="includeIntrons && (include5PrimeUtr && fivePrimeIntronCount > 0 || include3PrimeUtr && threePrimeIntronCount > 0)">
              <div *ngIf="include5PrimeUtr">
                <div *ngIf="fivePrimeIntronCount == 1">(Includes one 5'UTR intron)</div>
                <div *ngIf="fivePrimeIntronCount > 1">(Includes {{fivePrimeIntronCount}} introns in the 5'UTR)</div>
              </div>
              <div *ngIf="include3PrimeUtr">
                <div *ngIf="threePrimeIntronCount == 1">(Includes one 3'UTR intron)</div>
                <div *ngIf="threePrimeIntronCount > 1">(Includes {{threePrimeIntronCount}} introns in the 3'UTR)</div>
              </div>
            </div>
            </div>

            <div class="checkbox-section" *ngIf="featureHasProtein()">
            <div *ngIf="has3PrimeUtr">
            <input id="include-3-prime" type="checkbox" [(ngModel)]="include3PrimeUtr"
                   (ngModelChange)="updateSequence()"/>
            <label for="include-3-prime">3'UTR</label>
            </div>
            <div *ngIf="!has3PrimeUtr">
              (no 3' UTR)
            </div>
            </div>
            <div class="flanking-bases">
              <input title="Downstream bases" id="downstream-bases" type="number" min="0"
                     [(ngModel)]="downstreamBases" (ngModelChange)="updateSequence()"/>
              bases downstream
              <span *ngIf="featureHasProtein() && include3PrimeUtr">of UTR</span>
              <span *ngIf="!(featureHasProtein() && include3PrimeUtr)">
                <span *ngIf="featureHasProtein()">of translation end</span>
                <span *ngIf="!featureHasProtein()">of gene end</span>
              </span>
            </div>
          </div>

          <div [class.sequence-actions]="showNucSequence"
               [class.translation-sequence-actions]="!showNucSequence">

            <div *ngIf="!downloadWithFeaturesURL && (wrappedSequence || !showNucSequence)" class="sequence-action download-action">
              <button class="btn btn-primary" (click)="download()" title="Download the sequence in FASTA format">
                Download as FASTA
              </button>
            </div>

            <div *ngIf="downloadWithFeaturesURL" id="download-seq-menu" class="btn-group" dropdown>
               <button dropdownToggle type="button" class="btn btn-primary dropdown-toggle">
                 Download sequence:
               </button>

               <ul id="download-dropdown" *dropdownMenu class="dropdown-menu" role="menu">
                 <li class="dropdown-item" role="menuitem" *ngIf="wrappedSequence || !showNucSequence">
                   <a (click)="download()"
                      title="Download the sequence in FASTA format">Displayed sequence as FASTA</a>
                 </li>

                 <li class="dropdown-item" role="menuitem" *ngIf="wrappedSequence">
                   <a [href]="downloadWithFeaturesUrl('genbank')"
                      title="Download sequence and gene features in GenBank format">Genome region as GenBank</a>
                 </li>

                <li class="dropdown-item" role="menuitem" *ngIf="wrappedSequence">
                  <a [href]="downloadWithFeaturesUrl('embl')"
                     title="Download sequence and gene features in EMBL format">Genome region as EMBL</a>
                </li>
              </ul>
            </div>

             <div *ngIf="wrappedSequence" class="blast-actions">
             <span *ngIf="showNucSequence" class="sequence-action">
                <form id="ncbi-blast-gene-dna" name="NCBIBLASTDNA" #ncbidnaform
                      (ngSubmit)="ncbidnaform.submit()"
                      target="_blank"
                      action="https://blast.ncbi.nlm.nih.gov/Blast.cgi" method="GET">
                  <input name="QUERY" value="{{'>' + sequenceHeader + '\n' + wrappedSequence}}" type="hidden">
                  <input name="PROGRAM" value="blastn" type="hidden">
                  <input name="PAGE_TYPE" value="BlastSearch" type="hidden">
                  <input class="btn btn-primary" type="submit" value="NCBI BLASTN" />
                </form>
              </span>

              <span *ngIf="showNucSequence" class="sequence-action">
                <form id="ens-blast-gene-dna" name="BLASTGenomicSequenceDNA" #ensdnaform
                      (ngSubmit)="ensdnaform.submit();"
                      target="_blank"
                      action="{{ensemblBlastUrl}}?db=core" method="POST">
                  <input value="{{'>' + sequenceHeader + '\n' + wrappedSequence}}" name="query_sequence" type="hidden">
                  <input class="btn btn-primary" type="submit" value="Ensembl DNA BLAST" />
                </form>
              </span>

              <span *ngIf="!showNucSequence && geneDetails.feature_type == 'mRNA gene'" class="sequence-action">
                <form id="ncbi-blast-gene-prot" name="NCBIBLASTPROT" #ncbiprotform
                      (ngSubmit)="ncbiprotform.submit()"
                      target="_blank"
                      action="https://blast.ncbi.nlm.nih.gov/Blast.cgi" method="GET">
                  <input name="QUERY" value="{{'>' + proteinSequenceHeader + '\n' + wrappedProteinSequence}}" type="hidden">
                  <input name="PROGRAM" value="blastp" type="hidden">
                  <input name="PAGE_TYPE" value="BlastSearch" type="hidden">
                  <input class="btn btn-primary" type="submit" value="NCBI BLASTP" />
                </form>
              </span>

              <span *ngIf="!showNucSequence && geneDetails.feature_type == 'mRNA gene'" class="sequence-action">
                <form id="ens-blast-gene-prot" name="BLASTGenomicSequenceProt" #ensprotform
                      (ngSubmit)="ensprotform.submit();"
                      target="_blank"
                      action="{{ensemblBlastUrl}}?query=peptide;database=peptide" method="POST">
                  <input value="{{'>' + proteinSequenceHeader + '\n' + wrappedProteinSequence}}" name="query_sequence" type="hidden">
                  <input class="btn btn-primary" type="submit" value="Ensembl Protein BLAST" />
                </form>
              </span>

              <span *ngIf="!showNucSequence && geneDetails.feature_type == 'mRNA gene'" class="sequence-action">
                <form id="fastasearch" name="FastaSearch" #fastasearch
                      (ngSubmit)="fastasearch.submit();"
                      target="_blank"
                      action="{{ebiToolsUrl + '/fasta'}}" method="GET">
                  <input value="fasta" name="tool" type="hidden">
                  <input value="protein" name="context" type="hidden">
                  <input value="{{protein!.sequence}}" name="wflSequence" type="hidden">
                  <input class="btn btn-primary" type="submit" value="FASTA Search" />
                </form>
              </span>

              <span *ngIf="!showNucSequence && geneDetails.feature_type == 'mRNA gene'" class="sequence-action">
                <form id="psisearch" name="PSISearch" #psisearch
                      (ngSubmit)="psisearch.submit();"
                      target="_blank"
                      action="{{ebiToolsUrl + '/psisearch'}}" method="GET">
                  <input value="protein" name="context" type="hidden">
                  <input value="{{protein!.sequence}}" name="wflSequence" type="hidden">
                  <input class="btn btn-primary" type="submit" value="PSI-Search" />
                </form>
              </span>

              <span *ngIf="!showNucSequence && geneDetails.feature_type == 'mRNA gene'" class="sequence-action">
                <form id="psiblast" name="PSIBLAST" #psiblast
                      (ngSubmit)="psiblast.submit();"
                      target="_blank"
                      action="{{ebiToolsUrl + '/psiblast'}}" method="GET">
                  <input value="protein" name="context" type="hidden">
                  <input value="{{protein!.sequence}}" name="wflSequence" type="hidden">
                  <input class="btn btn-primary" type="submit" value="PSI-BLAST" />
                </form>
              </span>
            </div>
          </div>

          <div class="external-refs">
            <h5 class="title">
              Sequence resources
            </h5>

            <div class="ref-table">
              <app-external-refs-table [geneDetails]="geneDetails" [useNameAsLink]="true" [sectionFilter]="'transcript-sequence'">
              </app-external-refs-table>
            </div>
          </div>
        </div>

        <div class="sequence-holder" *ngIf="getDisplaySequence()">
          <div class="selected-range">
            <div>
          <div *ngIf="selectedResidueRange">
            {{selectedResidueMessage()}}
          </div>
            </div>
            <div class="clear-and-manual-select">
          <span class="clear-selection" *ngIf="selectedResidueRange">
            <a (click)="clearSelection()">Clear selection</a>
          </span>

          <span *ngIf="!showNucSequence" class="manual-selection">
            <a *ngIf="!selectedResidueRange && !manualSelectionVisible" (click)="manualSelectionVisible=true;">Manually select residues</a>
            <span *ngIf="manualSelectionVisible && !selectedResidueRange">
              Select range: <input [(ngModel)]="manualSelection" (change)="manualSelectionChanged()"
                                   placeholder="Examples: 10..25 or 15-30 or 40" autofocus>
              <span class="manual-selection-error" *ngIf="manualSelectionErrorMessage">error: {{manualSelectionErrorMessage}}</span>
            </span>
          </span>
          </div>
          </div>

          <div class="sequence-display" (mousemove)="checkSelection()" (mouseup)="checkSelection()">
          <div *ngIf="wrappedSequence || wrappedProteinSequence">
          <div class="header">
&gt;{{getSequenceHeader()}}
          </div>
          <div class="residues"><span class="residue-part" *ngFor="let part of getDisplaySequence()!.getParts()"
                   title="{{partTitle(part)}}" class="{{partClass(part)}}"
                   #partSpan
                 (mouseenter)="mouseenter(part)" (mouseleave)="mouseleave()"
                 (mousedown)="clearManualSelection()"
                 [attr.data-part-id]="part.partId">{{part.residues}}</span></div>
          </div>
          <div *ngIf="!wrappedSequence && showNucSequence">
            (No sequence to display)
          </div>
          <app-loading-spinner *ngIf="wrappedSequence == null"></app-loading-spinner>
          </div>
        </div>
    </div>
    <div *ngIf="!hasTranscripts">
      This gene has no transcripts available
    </div>
  </div>
</fieldset>
